import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  View,
  Text,
  Link,
  Font,
  StyleSheet,
  Image,
  Line,
} from "@react-pdf/renderer";
import ier_logo from "../../assets/images/icons/ier-logo2.png";
import moment from "moment";

const styles = StyleSheet.create({
  title: {
    margin: 20,
    fontSize: 25,
    textAlign: "center",
    backgroundColor: "#e4e4e4",
    textTransform: "uppercase",
    fontFamily: "Oswald",
  },
  title_container: {
    display: "flex",
    flexDirection: "row",
    padding: "40px 20px",
    backgroundColor: "#e7eaf3",
  },
  title_text: {
    fontSize: 10,
  },
  text_container: {
    flex: 1,
    marginLeft: 20,
  },
  logo: {
    width: "100%"
  },
  header_title: {
    fontWeight: "bold",
    fontSize: 20,
    color: "#0C8444",
    textTransform: "uppercase",
  },
  body: {
    flexGrow: 1,
    padding: "20px 10px",
    marginTop: 20,
  },
  row: {
    borderBottomWidth: 1,
    borderBottomColor: "#e4e4e4",
    paddingVertical: 15,
  },
  content_title: {
    fontSize: 16,
    marginBottom: 5,
    color: "#2596bc",
    fontFamily: "Oswald",
  },
  content_sub_title: {
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "Oswald",
  },
  content_container: {
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: 40,
    width: "50%",
  },
  content_sub_container: {
    padding: "10px 0px",
  },
  seperator: {
    border: "2px dashed #D6D6D6",
  },
  receipt_container: {
    display: "flex",
    flexDirection: "row",
  },
  receipt_container_left_ctn: {
    width: "70%",
    marginRight: 20,
  },
  receipt_container_right_ctn: {
    width: "30%",
  },
  receipt_container_right_sub_ctn: {
    padding: "10px",
  },
  content_title_right: {
    fontSize: 12,
    marginBottom: 5,
    color: "#2596bc",
    fontFamily: "Oswald",
  },
  content_sub_title_right: {
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Oswald",

    // textTransform: 'lowercase'
  },
});

Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

const ReceiptPDF = (props) => {
  const [details, setDetails] = useState("");

  useEffect(() => {
    setDetails(props.data);
  }, [props.data]);
  console.log("I am details in details", details);
  return (
    <Document>
      <Page size="A4" style={{ paddingBottom: 10 }}>
        <View style={styles.title_container}>
          <Image src={ier_logo} style={styles.logo} />
        </View>
        {/* <Text style={styles.header_title}>Bill details</Text> */}
        <View style={styles.body}>
          <View style={styles.receipt_container}>
            <View style={styles.receipt_container_left_ctn}>
              <View style={styles.receipt_container_right_sub_ctn}>
                <Text style={styles.content_title}>Item Type</Text>
                <Text
                  style={[
                    styles.content_sub_title,
                    { textTransform: "capitalize" },
                  ]}
                >
                  {details?.itemType}
                </Text>
              </View>
              <View style={styles.receipt_container_right_sub_ctn}>
                <Text style={styles.content_title_right}>Description</Text>
                <Text style={styles.content_sub_title}>
                  {details?.description}
                </Text>
              </View>
              <View style={styles.receipt_container_right_sub_ctn}>
                <Text style={styles.content_title}>Amount</Text>
                <Text style={styles.content_sub_title}>
                  RWF {details?.amount}
                </Text>
              </View>
            </View>
            <View style={styles.receipt_container_right_ctn}>
              <View style={styles.receipt_container_right_sub_ctn}>
                <Text style={styles.content_title}>Amount Due (RWF)</Text>
                <Text style={[styles.content_sub_title, { fontSize: 20 }]}>
                  RWF {details?.amount}
                </Text>
              </View>
              <View style={styles.receipt_container_right_sub_ctn}>
                <Text style={styles.content_title}>Billed To</Text>
                <Text style={styles.content_sub_title}>
                  {details?.payerInfo?.name}
                </Text>
              </View>
              <View style={styles.receipt_container_right_sub_ctn}>
                <Text style={styles.content_title}>Invoice Number</Text>
                <Text style={styles.content_sub_title}>{details?.id}</Text>
              </View>
              <View style={styles.receipt_container_right_sub_ctn}>
                <Text style={styles.content_title}>Date of Issue</Text>
                <Text style={styles.content_sub_title}>
                  {moment(details?.recordDate).format(
                    "MMMM Do YYYY, h:mm:ss a"
                  )}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ReceiptPDF;
